import CellAccessByDefault from './CellAccessByDefault';

export default CellAccessByDefault;
